<template>
    <div class="sidebar-cart-item align-items-center">
        <a :href="productUrl(cartItem.product)" class="product-image">
            <img
                v-if="typeof cartItem.custom_image !== 'undefined' && cartItem.custom_image !== null && cartItem.custom_image !== ''"
                :src="cartItem.custom_image"
                alt="product image">
            <img
                v-else
                :src="baseImage(cartItem.product)"
                :class="{ 'image-placeholder': ! hasBaseImage(cartItem.product) }"
                alt="product image"
            >
        </a>

        <div class="product-info">

            <div class="product-price-cart mb-2">
                <span v-html="cartItem.unitPrice.inCurrentCurrency.formatted"></span>
            </div>

            <a :href="productUrl(cartItem.product)" class="product-name mb-1" :title="cartItem.product.name">
                {{ cartItem.product.name }}
            </a>

            <ul class="list-inline product-options">
                <li v-for="option in cartItem.options" :key="option.id">
                    <label>{{ option.name }}:</label> {{ optionValues(option) }}
                </li>
            </ul>

            <div class="product-quantity">
                Qty: {{ cartItem.qty }} {{cartItem.custom_order_qty}}
            </div>
        </div>

        <div class="d-flex flex-column align-items-center ml-auto" style="gap: 0.5rem">
            <a class="btn-remove" v-if="cartItem.custom_product_type === 2" :href="route('storefront.image_editor.edit_cart_item', cartItem.id)" style="position: relative; left: 1px">
                <i class="las la-edit"></i>
            </a>

            <button class="btn-remove p-0" @click="remove">
                <i class="las la-trash"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import store from '../../store';
    import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';

    export default {
        mixins: [
            ProductHelpersMixin,
        ],

        props: ['cartItem'],

        methods: {
            optionValues(option) {
                let values = [];

                for (let value of option.values) {
                    values.push(value.label);
                }

                return values.join(', ');
            },

            remove() {
                store.removeCartItem(this.cartItem);

                $.ajax({
                    method: 'DELETE',
                    url: route('cart.items.destroy', { cartItemId: this.cartItem.id }),
                }).then((cart) => {
                    store.updateCart(cart);
                });
            },
        },
    };
</script>
